import { useState, type FormEvent } from 'react'
import { Navigate, useLocation } from 'react-router-dom'

import { Botao } from '../../components/Botao'
import { useSessao } from '../../stores/sessao'
import estilos from './LoginPage.module.css'

export function LoginPage() {
  const { usuario, entrar, entrandoEm, erroLogin } = useSessao()
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const local = useLocation() as { state?: { de?: string } }

  // Quem já está autenticado volta para onde tentou ir antes de ser barrado.
  if (usuario) return <Navigate to={local.state?.de ?? '/delta'} replace />

  async function enviar(evento: FormEvent) {
    evento.preventDefault()
    await entrar(username, password)
  }

  return (
    <div className={estilos.tela}>
      <form className={estilos.cartao} onSubmit={(evento) => void enviar(evento)}>
        <div className={estilos.marca}>
          <h1 className={estilos.titulo}>Análise de Pricing</h1>
          <p className={estilos.sub}>Inteligência de preços de combustíveis</p>
        </div>

        <label className={estilos.campo}>
          <span className={estilos.rotulo}>Usuário</span>
          <input
            className={estilos.entrada}
            value={username}
            onChange={(evento) => setUsername(evento.target.value)}
            autoComplete="username"
            autoFocus
            required
          />
        </label>

        <label className={estilos.campo}>
          <span className={estilos.rotulo}>Senha</span>
          <input
            className={estilos.entrada}
            type="password"
            value={password}
            onChange={(evento) => setPassword(evento.target.value)}
            autoComplete="current-password"
            required
          />
        </label>

        {/*
          A mensagem vem do servidor e é genérica de propósito ("Credenciais
          inválidas") — não revela se o usuário existe. `role="alert"` para o
          leitor de tela anunciar sem que o foco saia do formulário.
        */}
        {erroLogin && (
          <p className={estilos.erro} role="alert">
            {erroLogin}
          </p>
        )}

        <Botao type="submit" variante="primario" carregando={entrandoEm}>
          {entrandoEm ? 'Entrando…' : 'Entrar'}
        </Botao>
      </form>
    </div>
  )
}
